<div id="conferencia-volumes" class="container-fluid">
    <h3>Conferência de volumes</h3>
    <mat-card id="filters">
      <mat-card-header class="header-padrao">
        <mat-card-title>
          <form
            class="d-flex align-items-center filtros-header"
            [formGroup]="filterForm"
          >

          <mat-form-field>
            <mat-label>Data Inicial:</mat-label>
            <input matInput
              autocomplete="off"
              maskDate [matDatepicker]="dataInicio"
              formControlName="dataInicio"
              required
              maskDate
              >
            <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
            <mat-datepicker #dataInicio></mat-datepicker>
          </mat-form-field>



          <mat-form-field>
            <mat-label>Data Final:</mat-label>
            <input matInput
              autocomplete="off"
              maskDate [matDatepicker]="dataFim"
              formControlName="dataFim"
              required
              maskDate
              >
            <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
            <mat-datepicker #dataFim></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Filial Origem:</mat-label>
            <mat-select formControlName="filialSelecionado"
              disableOptionCentering="true"
              placeholder="Filial Origem"
              [(ngModel)]="filialIdSelecionado">
              <mat-option><ngx-mat-select-search [formControl]="filialMultiFilter" placeholderLabel="Buscar..." noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option selected value="">Todas</mat-option>
              <mat-option *ngFor="let filial of filteredFiliais | async" [value]="filial?.filialID">
                {{filial?.descricao}}
              </mat-option>
            </mat-select>
          </mat-form-field>

            <mat-form-field>
              <mat-label>Código Packing list:</mat-label>
              <input
                matInput
                type="number"
                placeholder="Código"
                formControlName="codigoPacking"
                maxlength="10"
              />
            </mat-form-field>

            <app-cliente-autocomplete
              [clienteRisco]="true"
              [form]="filterForm"
              (clienteIdOutput)="reciverFeedback($event)"></app-cliente-autocomplete>

            <mat-form-field>
              <mat-label>Produto:</mat-label>
              <mat-select formControlName="produto">
                <mat-option value="">Todos</mat-option>
                <mat-option *ngFor="let produto of produtos" [value]="produto.produtoID">
                  {{produto.descricao}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button mat-icon-button (click)="paging.index = 0; clearFields()" matTooltip="Limpar Campos">
              <i class="fas fa-eraser eraser-button"></i>
            </button>
            <button
              mat-icon-button
              (click)="paging.index = 0; getGridVolumes()"
              [disabled]="filterForm.invalid"
            >
              <i
                class="fas fa-search search-button cursor-pointer-icon"
                matTooltip="Pesquisar"
              ></i>
            </button>
          </form>
        </mat-card-title>
      </mat-card-header>
      <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
      <mat-card-content class="no-padding">
        <div [hidden]="isLoading || !gridVolumes?.data?.length">
          <div>
            <table id="relatorios"
              mat-table
              [dataSource]="gridVolumes"
              class="table-sm">
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let gridVolumes" width="90px">
                  <button mat-icon-button
                    [matMenuTriggerFor]="menu"
                    [ngClass]="{ 'disabled' : (!acessoDetalhes && !acessoAcompanhamento && !acessoProdutoRisco) }"
                    aria-label="Example icon-button with a menu">
                      <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button *ngIf="acessoDetalhes"
                      mat-menu-item
                      color="primary"
                      (click)="modalDetalhesLote(gridVolumes.numLote)">
                        <mat-icon fontSet="fas" fontIcon="fa-edit"></mat-icon>
                        <span>Detalhes do lote</span>
                    </button>
                    <button *ngIf="acessoAcompanhamento"
                      mat-menu-item
                      color="primary"
                      (click)="modalAcompanharRemessa(gridVolumes)">
                        <mat-icon fontSet="fas" fontIcon="fa-edit"></mat-icon>
                        <span>Acompanhar Remessa</span>
                    </button>
                    <button *ngIf="acessoProdutoRisco"
                      mat-menu-item
                      color="primary"
                      (click)="modalConfirmacao(
                        gridVolumes.produtoRisco
                          ? 'Os Produtos já estão classificados como Risco, deseja voltar ao seu estado original?'
                          : 'Todos os produtos deste lote serão classificados como de risco, deseja continuar?',
                        gridVolumes.produtoRisco
                          ? 'transformarOriginal'
                          : 'transformarRisco',
                        gridVolumes
                      )">
                        <mat-icon fontSet="fas" fontIcon="fa-edit"></mat-icon>
                        <span>{{ gridVolumes.produtoRisco ? 'Voltar Produto ao Original' : 'Transformar Produto em Risco' }}</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <ng-container matColumnDef="codigo">
                <th mat-header-cell *matHeaderCellDef>Código</th>
                <td mat-cell *matCellDef="let gridVolumes">
                  {{ gridVolumes.codigo }}
                </td>
              </ng-container>

              <ng-container matColumnDef="codigoPackingList">
                <th mat-header-cell *matHeaderCellDef>Código Packing List</th>
                <td mat-cell *matCellDef="let gridVolumes">
                  {{ gridVolumes.codigoPackingList }}
                </td>
              </ng-container>

              <ng-container matColumnDef="cliente">
                <th mat-header-cell *matHeaderCellDef>Cliente</th>
                <td mat-cell *matCellDef="let gridVolumes">
                  {{ gridVolumes.cliente }}
                </td>
              </ng-container>

              <ng-container matColumnDef="produto">
                <th mat-header-cell *matHeaderCellDef>Produto</th>
                <td mat-cell *matCellDef="let gridVolumes">
                  {{ gridVolumes.produto }}
                </td>
              </ng-container>

              <ng-container matColumnDef="filialOrigem">
                <th mat-header-cell *matHeaderCellDef>Filial Origem</th>
                <td mat-cell *matCellDef="let gridVolumes">
                  {{ gridVolumes.filialOrigem }}
                </td>
              </ng-container>

              <ng-container matColumnDef="numLote">
                <th mat-header-cell *matHeaderCellDef>Nº Lote</th>
                <td mat-cell *matCellDef="let gridVolumes">
                  {{ gridVolumes.numLote }}
                </td>
              </ng-container>

              <ng-container matColumnDef="qtde">
                <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                <td mat-cell *matCellDef="let gridVolumes">
                  {{ gridVolumes.qtde}}
                </td>
              </ng-container>

              <ng-container matColumnDef="dtEntrada">
                <th mat-header-cell *matHeaderCellDef>Data Inclusão</th>
                <td mat-cell *matCellDef="let gridVolumes">
                  {{ gridVolumes.dtEntrada | date: "dd/MM/yyyy - HH:mm:ss" }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
          <app-paginacao [pageIndex]="paging?.index"
            [pageSize]="paging?.size"
            [length]="paging?.length"
            (page)="onPageChange($event)"
            [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
          <div class="text-right p-1">
            <button mat-flat-button type="button" color="success" (click)="downloadExcel()"
              [disabled]="isLoadingDownload">
              <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
                <mat-spinner diameter="20" color="dark"></mat-spinner>
                &nbsp; Baixando
              </span>
              <span *ngIf="!isLoadingDownload">
                <i class="fas fa-file-excel"></i> Download Excel
              </span>
            </button>
          </div>
        </div>
        <div
          *ngIf="!isLoading && gridVolumes?.data?.length === 0"
          class="d-flex justify-content-center align-items-center"
          style="height: 100px"
        >
          Nenhum resultado encontrado!
        </div>
      </mat-card-content>
    </mat-card>
  </div>
